import styles from './TopMenu.module.css';
import { isAuthenticated } from '../../index';
import React, { useEffect, useState, useRef } from "react";
import { FaArrowLeft } from 'react-icons/fa';
import notifications from '../notifications';
import { useLocation } from 'react-router-dom';
import BarraPesquisa from "../barraDePesquisa/barraPesquisa";
import Pesquisa from "../barraDePesquisa/pesquisa";

export default function TopMenu() {
  const Logo = process.env.REACT_APP_LOGO_URL || 'Logo.png';
  const { userPermission } = isAuthenticated();

  const [notificationType, setNotificationType] = useState(0);
  const [comissao] = useState({
    somaQuinzena1: 0,
    comissaoQuinzena1: 0,
    somaQuinzena2: 0,
    comissaoQuinzena2: 0
  });

  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  const [previousPage, setPreviousPage] = useState('');

  useEffect(() => {
    if (document.referrer) {
      setPreviousPage(document.referrer);
    }
  }, []);

  const location = useLocation();
  const pathname = location.pathname;

  const showBtnVoltar =
    !!previousPage &&
    pathname !== '/crm' &&
    pathname !== '/signin' &&
    pathname !== '/' &&
    !pathname.startsWith('/formularios') &&
    !pathname.startsWith('/parceirosPage');

  const hideComissaoByPath = pathname.includes('VisaMatchApp');

  const showComissao =
    !pathname.startsWith('/formularios') &&
    pathname !== '/signin' &&
    pathname !== '/' &&
    !pathname.startsWith('/preencher') &&
    !pathname.startsWith('/parceirosPage') &&
    comissao.comissaoQuinzena1 !== 0 &&
    comissao.comissaoQuinzena1 !== null &&
    comissao.comissaoQuinzena2 !== 0 &&
    comissao.comissaoQuinzena2 !== null;

  const goBack = () => {
    if (previousPage) {
      window.location.href = previousPage;
    } else {
      console.log("Nenhuma página anterior detectada");
    }
  };

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const dayToday = today.getDate();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const renderDays = (start, end) => {
    const days = [];
    for (let day = start; day <= end; day++) {
      const isPast = day < dayToday;
      const isToday = day === dayToday;

      days.push(
        <div
          key={day}
          className={`${styles.day} ${isPast ? styles.past : isToday ? styles.today : styles.future}`}
        >
        </div>
      );
    }
    return days;
  };

  const logoRef = useRef(null);

  return (
    <div className={styles.container}>
      {userPermission === 99 ? (
        <div
          style={{
            position: "absolute",
            top: "40px",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90vw",
            maxWidth: "600px",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "block",
            }}
          >
            <div
              style={{
                position: "relative",
                left: 0,
                right: "auto",
                width: "100%",
                maxWidth: "100%",
              }}
            >
              <BarraPesquisa
                placeholder="Buscar usuário, vendedor, produtor, contato, DS-160..."
                expandedWidth="100%"
                collapsedSize={44}
                panelMaxHeight={480}
                ContentComponent={Pesquisa}
                contentProps={{}}
                onSearch={(q) => console.log("Buscar:", q)}
              />
            </div>
          </div>
        </div>
      ) : null}

      <div className={styles.logoContainer}>
        {userPermission === 99 ? (
          <a ref={logoRef} href="../crm" style={{ zIndex: "1001" }} className={styles.buttonVoltar}>
            <img className={styles.logo} src={Logo} alt="Logo" />
          </a>
        ) : (
          <div ref={logoRef} className={styles.buttonVoltar}>
            <img className={styles.logo} src={Logo} alt="Logo" />
          </div>
        )}
      </div>

      {showBtnVoltar && (
        <div className={styles.btnVoltarContainer}>
          <button
            onClick={goBack}
            style={{
              borderRadius: "20px",
              border: "solid 1px ",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px"
            }}
          >
            <FaArrowLeft /> Voltar
          </button>
        </div>
      )}

      {hideComissaoByPath ? (
        <div style={{ padding: "20px", color: "white", fontSize: ".8rem", textAlign: "center" }}>
          <a
            style={{ color: "white", fontSize: ".8rem", textAlign: "center" }}
            href="https://api.whatsapp.com/send?phone=5561998819381&text=Ol%C3%A1%2C%20vim%20pelo%20teste%20online%20gostaria%20de%20agilizar%20o%20meu%20visto!%20Algu%C3%A9m%20pode%20me%20ajudar%3F"
          >
            Para entrar em contato com um especialista online, clique aqui.
          </a>
        </div>
      ) : (
        <div className={styles.comissaoVendedorBOX}>
          {Number(userPermission) !== 0 && (
            <div
              style={{
                width: "90%",
                maxWidth: "600px",
                backgroundColor: "#c2d5ff",
                borderRadius: "20px",
                marginBlock: "10px",
              }}
            >
              <div style={{ width: "100%", marginBlock: "10px" }}>
                <h3 style={{ textAlign: "center", color: "var(--corPrimaria)" }}>
                  {today.toLocaleString('pt-BR', { month: 'long' }).charAt(0).toUpperCase() +
                    today.toLocaleString('pt-BR', { month: 'long' }).slice(1)}
                </h3>

                <div className={styles.calendarprogress}>
                  <div className={styles.row}>{renderDays(1, 15)}</div>

                  {showComissao && (
                    <ul>
                      <li>Comissão: R$ {comissao.comissaoQuinzena1.toFixed(2)}</li>
                    </ul>
                  )}

                  <div className={styles.row}>{renderDays(16, daysInMonth)}</div>

                  {showComissao && (
                    <ul>
                      <li>Comissão: R$ {comissao.comissaoQuinzena2.toFixed(2)}</li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}